module.exports = __webpack_public_path__ + "media/images/admin/icon/icon_off-f481e47574e87a7b59824ec1a1fb9b38.svg";